/**
 * App 그룹 브릿지 메소드
 */

import { sendMessageToApp } from '@/lib/bridge'
import type { ActionRequest, ActionResponse } from '@/lib/bridge/types'

import type { AppGroup } from './types'

// App 그룹의 액션 타입
export type AppAction = keyof AppGroup

/**
 * getConfig 호출
 */
export const getConfig = async (): Promise<ActionResponse<'App', 'getConfig'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'getConfig',
    data: null
  })
}

/**
 * getColor 호출
 */
export const getColor = async (): Promise<ActionResponse<'App', 'getColor'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'getColor',
    data: null
  })
}

/**
 * getValue 호출
 */
export const getValue = async (
  params: ActionRequest<'App', 'getValue'>
): Promise<ActionResponse<'App', 'getValue'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'getValue',
    data: params
  })
}

/**
 * putValue 호출
 */
export const putValue = async (
  params: ActionRequest<'App', 'putValue'>
): Promise<ActionResponse<'App', 'putValue'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'putValue',
    data: params
  })
}

/**
 * copyToClipboard 호출
 */
export const copyToClipboard = async (
  params: ActionRequest<'App', 'copyToClipboard'>
): Promise<ActionResponse<'App', 'copyToClipboard'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'copyToClipboard',
    data: params
  })
}

/**
 * isPassedTargetPackages 호출
 */
export const isPassedTargetPackages = async (
  params: ActionRequest<'App', 'isPassedTargetPackages'>
): Promise<ActionResponse<'App', 'isPassedTargetPackages'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'isPassedTargetPackages',
    data: params
  })
}

/**
 * track 호출
 */
export const track = async (params: ActionRequest<'App', 'track'>): Promise<ActionResponse<'App', 'track'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'track',
    data: params
  })
}

/**
 * openRequest 호출
 */
export const openRequest = async (
  params: ActionRequest<'App', 'openRequest'>
): Promise<ActionResponse<'App', 'openRequest'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'openRequest',
    data: params
  })
}

/**
 * sessionClear 호출
 */
export const sessionClear = async (): Promise<ActionResponse<'App', 'sessionClear'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'sessionClear',
    data: null
  })
}

/**
 * getRequestId 호출
 */
export const getRequestId = async (): Promise<ActionResponse<'App', 'getRequestId'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'getRequestId',
    data: null
  })
}

/**
 * addImpression 호출
 */
export const addImpression = async (
  params: ActionRequest<'App', 'addImpression'>
): Promise<ActionResponse<'App', 'addImpression'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'addImpression',
    data: params
  })
}

/**
 * requestParticipate 호출
 */
export const requestParticipate = async (
  params: ActionRequest<'App', 'requestParticipate'>
): Promise<ActionResponse<'App', 'requestParticipate'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'requestParticipate',
    data: params
  })
}

/**
 * isPackageInstalled 호출
 */
export const isPackageInstalled = async (
  params: ActionRequest<'App', 'isPackageInstalled'>
): Promise<ActionResponse<'App', 'isPackageInstalled'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'isPackageInstalled',
    data: params
  })
}

/**
 * insertCpiAd 호출
 */
export const insertCpiAd = async (
  params: ActionRequest<'App', 'insertCpiAd'>
): Promise<ActionResponse<'App', 'insertCpiAd'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'insertCpiAd',
    data: params
  })
}

/**
 * isMarketEnabled 호출
 */
export const isMarketEnabled = async (): Promise<ActionResponse<'App', 'isMarketEnabled'>> => {
  return await sendMessageToApp({
    group: 'App',
    action: 'isMarketEnabled',
    data: null
  })
}
